<template>
  <soha-modal
    id="editResume"
    :title="$t(`${I18nPrefix}TITLE`)"
    @hide="clearModalData"
  >
    <template #activator />
    <template #body>
      <soha-text-field
        v-model="firstName.value"
        name="firstName"
        :error="firstName.error"
        class="w-100 my-3"
        :placeholder="$t(`${I18nPrefix}FIRST_NAME`)"
      />
      <soha-text-field
        v-model="lastName.value"
        name="lastName"
        :error="lastName.error"
        class="w-100 my-3"
        :placeholder="$t(`${I18nPrefix}LAST_NAME`)"
      />
      <soha-text-field
        v-model="mobile.value"
        name="mobile"
        type="number"
        :error="mobile.error"
        class="w-100 my-3"
        :max-length="11"
        :placeholder="$t(`${I18nPrefix}MOBILE`)"
      />
      <soha-text-field
        v-model="email.value"
        name="email"
        :error="email.error"
        class="w-100 my-3"
        :placeholder="$t(`${I18nPrefix}EMAIL`)"
      />
      <soha-text-field
        v-model="phone"
        name="phone"
        type="number"
        class="w-100 my-3"
        :placeholder="$t(`${I18nPrefix}PHONE`)"
        :max-length="11"
      />
      <soha-text-field
        v-model="nationalIdCode"
        name="nationalIdCode"
        type="number"
        class="w-100 my-3"
        :placeholder="$t(`${I18nPrefix}NATIONAL_CODE`)"
        :max-length="10"
      />
      <soha-select
        v-model="genderId"
        name="gender"
        class="w-100 my-3"
        :placeholder="$t(`${I18nPrefix}GENDER`)"
        :options="gender"
      />
      <soha-select
        v-model="cityId"
        name="city"
        class="w-100 my-3"
        :placeholder="$t(`${I18nPrefix}CITY`)"
        :options="provinceCities"
      />
    </template>
    <template #footer>
      <soha-button
        name="editResume"
        variant="primary"
        :text="$t(`${I18nPrefix}EDIT`)"
        :loading="loading"
        @btn-click="editResume"
      />
    </template>
  </soha-modal>
</template>

<script>
import { mapGetters } from "vuex";
import GeneralMixin from "@/mixins/GeneralMixin";
import ApiService from "@/core/services/api.service";
import UIMixin from "@/mixins/UIMixin";
import ValidationMixin from "@/mixins/ValidationMixin";

export default {
  name: "ResumeModalEdit",

  mixins: [GeneralMixin, UIMixin, ValidationMixin],

  data() {
    return {
      I18nPrefix: "COMPONENTS.RESUME.RESUME_EDIT_MODAL.",
      loading: false,
      firstName: {
        value: null,
        error: null,
      },
      lastName: {
        value: null,
        error: null,
      },
      mobile: {
        value: null,
        error: null,
      },
      email: {
        value: null,
        error: null,
      },
      phone: null,
      nationalIdCode: null,
      genderId: null,
      gender: [
        {
          id: null,
          text: this.$t(`COMPONENTS.RESUME.RESUME_EDIT_MODAL.NOT_SELECTED`),
        },
        {
          id: 1,
          text: this.$t(`COMPONENTS.RESUME.RESUME_EDIT_MODAL.FEMALE`),
        },
        {
          id: 2,
          text: this.$t(`COMPONENTS.RESUME.RESUME_EDIT_MODAL.MALE`),
        },
      ],
      cityId: null,
      provinceCities: [],
      resumeId: null,
    };
  },

  mounted() {
    this.getProvinceCities((data) => (this.provinceCities = data));
  },

  methods: {
    editResume() {
      this.firstName.error = this.validateField(
        this.firstName.value,
        this.$t(`${this.I18nPrefix}FIRST_NAME`)
      );
      this.lastName.error = this.validateField(
        this.lastName.value,
        this.$t(`${this.I18nPrefix}LAST_NAME`)
      );
      this.mobile.error = this.validatePhoneNumber(this.mobile.value);
      this.email.error = this.validateEmailFormat(this.email.value);
      if (
        !this.firstName.error &&
        !this.lastName.error &&
        !this.mobile.error &&
        !this.email.error
      ) {
        this.loading = true;
        ApiService.put(`api/v2/resumes/${this.resumeId}`, {
          firstName: this.firstName.value,
          lastName: this.lastName.value,
          mobile: this.mobile.value,
          email: this.email.value,
          genderId: this.genderId,
          cityId: this.cityId,
          phoneNumber: this.phone,
          nationalIdCode: this.nationalIdCode,
        }).then(({ data }) => {
          if (+data.code === 204) {
            this.successToast(data.message);
            this.loading = false;
            this.$modal.hide("editResume");
            this.$emit("resumeEdited");
          } else {
            this.errorToast(data.message);
          }
          this.loading = false;
        });
      }
    },

    clearModalData() {
      this.firstName = {
        value: null,
        error: null,
      };
      this.lastName = {
        value: null,
        error: null,
      };
      this.mobile = {
        value: null,
        error: null,
      };
      this.email = {
        value: null,
        error: null,
      };
      this.phone = null;
      this.nationalIdCode = null;
      this.genderId = null;
      this.city = null;
      this.$store.commit("removeEditItem");
    },
  },

  computed: {
    ...mapGetters(["editItem", "canDo"]),
  },

  watch: {
    editItem(newItem) {
      if (newItem) {
        this.firstName.value = newItem.firstName;
        this.lastName.value = newItem.lastName;
        this.email.value = newItem.email;
        this.mobile.value = newItem.mobile;
        this.phone = newItem.phoneNumber;
        this.nationalIdCode = newItem.nationalIdCode;
        this.genderId = newItem.genderId;
        this.cityId = newItem.cityId;
        this.resumeId = newItem.id;
      }
    },
  },
};
</script>

<style scoped></style>
